/**
 * True when a provider's credential identifies them as a CRNA.
 *
 * Drives anesthesia role eligibility (feature 044, FR-002/FR-003): the
 * Anesthesiologist role admits every provider this returns `false` for, the CRNA
 * role only those it returns `true` for.
 *
 * Matching is case-insensitive and token-based — the credential string is split on
 * non-alphanumeric characters, so `"CRNA"`, `"crna"`, `"CRNA, APRN"` and
 * `"APRN-CRNA"` all match while `"CRNAX"` does not. A blank or absent credential
 * is not a CRNA (spec A-002: such a provider is Anesthesiologist-eligible).
 */
export function isCrnaCredential(credential?: string | null): boolean {
  if (!credential) return false;
  return credential
    .split(/[^a-zA-Z0-9]+/)
    .some((token) => token.toUpperCase() === 'CRNA');
}
